interface CustomTimestamp {
  _seconds?: number;
  _nanoseconds?: number;
  seconds?: number;
  nanoseconds?: number;
}

export const timeStampToDate = (time: CustomTimestamp) => {
  if (time && time.seconds && !time._seconds) {
    const date = new Date(time?.seconds * 1000).toDateString();
    return date;
  }

  if (time && !time.seconds && time._seconds) {
    const date = new Date(time?._seconds * 1000).toDateString();
    return date;
  }

  return 'Undefined';
};

export const timeStampToTime = (time: CustomTimestamp) => {
  if (time.seconds && !time._seconds) {
    const date = new Date(time?.seconds * 1000).toTimeString().split(' ')[0];
    return date;
  }

  if (!time.seconds && time._seconds) {
    return new Date(time?._seconds * 1000).toTimeString().split(' ')[0];
  }

  return 'Undefined';
};
